require("./tri")
require("./accordion-mycb")
require("./accordion")
require("./calendar")
require("./courses")
require("./mycoursebin")
require("./register")
require("./search-courses")
require("./search-dept")
require("./session-info")